import React, { useState } from 'react'
import Modal from 'components/Modal'
import Icon from 'components/Icon'
import { RatesList } from 'containers/SupplierProfile/components/Rates'

const VoiceTalentValueLabel = ({ supplierId, dealId, children, ...props }) => {
  const [show, setShow] = useState(false)

  return (
    <span {...props}>
      { show &&
        <Modal
          onClose={() => setShow(false)}
          childClassName="sm:w-8/12 sm:max-w-screen-lg"
        >
          <a
            className="block text-center w-full p-4 border-b border-gray-200 bg-blue-100 hover:bg-blue-200 cursor-pointer text-xl text-blue-500"
            href={`https://my.voicearchive.com/supplier/${supplierId}/book?dealId=${dealId}`}
            target="_blank"
          >
            Create booking request <Icon icon="external-link" />
          </a>

          <div className="px-4 pb-4">
            <RatesList match={{ params: { supplierId } }} />
          </div>
        </Modal>
      }

      <span onMouseDown={() => setShow(true)}>
        { children }
      </span>
    </span>
  )
}

export default VoiceTalentValueLabel
